<template>
  <div class="sr-wrap sr-wrap--center">
    <div class="sr-box sr-box--mini">
      <div class="sr-box__header">
        <div class="sr-box__title">{{t('user.login.title.text_1')}}</div>
      </div>
      <div class="sr-box__content">
        <el-form ref="formRef" :model="form.fields" :rules="form.rules">
          <div class="sr-login__mode">
            <span :class="{'active': loginMode === LOGIN_MODE.CELLPHONE}" @click="handleModeChange">{{t('user.login.title.text_2')}}</span>
            <span :class="{'active': loginMode === LOGIN_MODE.EMAIL}" @click="handleModeChange">{{t('user.login.title.text_3')}}</span>
          </div>
          <el-form-item prop="loginName">
            <div class="sr-box__comb-item">
              <div class="comb-item__select" v-if="VISIBLE.ZONE_NUMBER">
                <sr-zone-number v-model:zone-number="form.fields.zoneNumber"></sr-zone-number>
              </div>
              <div class="comb-item__input">
                <el-input v-model="form.fields.loginName" :placeholder="form.schema.loginName.label[loginMode]"></el-input>
              </div>
            </div>
          </el-form-item>

          <el-form-item prop="password">
            <el-input v-model="form.fields.password" :placeholder="form.schema.password.label" type="password"></el-input>
          </el-form-item>

          <el-form-item prop="drag">
            <sr-drag ref="dragRef" v-model:confirm="form.fields.drag"></sr-drag>
          </el-form-item>
        </el-form>
      </div>
      <div class="sr-box__footer">
        <div class="sr-box__btn">
          <el-button type="primary" @click="handleLogin">{{t('user.login.content.text_4')}}</el-button>
        </div>

        <div :class="['sr-box__btn--text',localCN?'support-cn':'support-en']">
          <div class="btn--forget-pwd">
            <el-button type="text" @click="routeTo('/forgetPassword')">{{t('user.login.content.text_2')}}</el-button>
          </div>
          <div>
            <span>{{t('user.login.content.text_3_1')}}</span>
            <el-button type="text" @click="routeTo('/register')">{{t('user.login.content.text_3_2')}}</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, computed, onBeforeMount } from 'vue'
import { useStore } from 'vuex'
import { formComp, commonComp } from '@/compositions'
import SrZoneNumber from '@/components/SrZoneNumber'
import { LoginReq } from '@/domain/modules/login'
import { useI18n } from '@/plugins/i18n'
import { routeTo } from '@/utils'
import { cookieUtils, encryptUtils } from '@libs/utils'
import { components, utils } from '@libs/ui'

export default {
  name: 'login',
  components: {
    SrZoneNumber,
    SrDrag: components.SrDrag,
  },
  setup() {
    const store = useStore()
    const { createForm } = formComp()
    const { constant: { LOGIN_MODE, AUTH } } = commonComp()
    const { t } = useI18n()

    // todo - scopedComp
    const scopedComp = reactive({ t, routeTo, AUTH })

    // todo - refs
    const refs = reactive({
      formRef: null,
      dragRef: null,
      secondVerifyRef: null
    })

    // todo - data
    const state = reactive({
      form: createForm({ items: LoginReq }),
      loginMode: LOGIN_MODE.EMAIL
    })

    // todo - computed
    const scopedComputed = {
      VISIBLE: computed(() => {
        return {
          ZONE_NUMBER: (() => {
            return state.loginMode === LOGIN_MODE.CELLPHONE
          })()
        }
      })
    }

    // todo - methods
    const scopedMethods = {
      handleLogin: async () => {
        refs.formRef.validate(async valid => {
          if (valid) {
            try {
              const param = {
                loginName: state.form.fields.loginName,
                loginPassword: encryptUtils.encrypt(state.form.fields.password),
              }
              if (scopedComputed.VISIBLE.value.ZONE_NUMBER) {
                param.loginName = state.form.fields.zoneNumber + state.form.fields.loginName
              }
              await store.dispatch('user/login', param)
              scopedMethods.loginCallback()
            } finally {
              refs.dragRef.reset()
            }
          }
        })
      },
      loginCallback: () => {
        utils.vab.baseMessage(t('user.login.content.text_6'))
        routeTo('/dashboard')
      },
      handleModeChange: () => {
        state.loginMode = state.loginMode === LOGIN_MODE.CELLPHONE ? LOGIN_MODE.EMAIL : LOGIN_MODE.CELLPHONE
        state.form.fields.loginName = ''
        state.form.fields.password = ''
      },
      initExtraRules: () => {
        const validateLoginName = {
          required: true,
          trigger: 'blur',
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error(t(`modules.login.validate.loginName.${state.loginMode}`)))
            } else {
              callback()
            }
          }
        }

        state.form.rules.loginName.push(validateLoginName)
      }
    }

    onBeforeMount(() => {
      scopedMethods.initExtraRules()
    })

    return {
      ...toRefs(refs),
      ...toRefs(state),
      ...scopedComp,
      ...scopedComputed,
      ...scopedMethods,
      LOGIN_MODE
    }
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .support-en {
    display: flex;
    justify-content: space-between;
  }

  .support-cn {
    display: flex;
    justify-content: space-between;
  }

  @media screen and (max-width: 620px) {
    .support-en {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
    }
  }

  .btn--forget-pwd {
    .el-button {
      color: $--color-grey-heavy;
    }
  }

  .sr-login__mode {
    margin-bottom: 8px;
    color: $--color-grey-heavy;

    span {
      cursor: pointer;
      padding-right: 16px;
      font-size: 12px;

      &.active {
        color: $--color-primary;
      }
    }
  }

  .sr-wrap {
    height: auto;
  }
</style>
